<template>
    <div id="idImportadorCotizacionesFiltros" class="">
        <Button
            :size="15"
            color="#fd7e14"
            colorText="#ffffff"
            tooltip="Filtrar Contenido"
            icon="fas fa-filter"
            round
            :width="30"
            class="mt-2 mb-3 ml-2"
            @click.native="openModal('modal')"
            traslate
        />
        <ui-modal
            :title="`Filtro Cotizaciones`"
            size="large" 
            ref="modal" 
            @close="closeModal('modal')"
        >
            <div class="container-fluid">
                <div class="row w-100">
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Cotización" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="quotationsList"
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="quotation"
                        />
                    </div>

                    <div class="col-4">
                        <ui-textbox 
                            class="w-100" 
                            label="N° Cotización" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="quotation_number"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Naviera" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="navierasList"
                            multiple
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="naviera"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <label class="label-datepicker" >Desde</label>

                        <date-picker
                            class=" w-100" 
                            format="DD-MM-YYYY" 
                            type="date" 
                            valueType="format"
                            v-model="from"
                        />
                    </div>

                    <div class="col-4">
                        <label class="label-datepicker" >Hasta</label>

                        <date-picker 
                            label="Hasta"
                            class="w-100" 
                            format="DD-MM-YYYY" 
                            type="date" 
                            valueType="format"
                            v-model="to"
                        />
                    </div>
                </div>

                <div class="row w-100 mt-4">
                    <div class="col">
                        <div class="w-100">
                            <button class="btn btn-default" @click="closeModal('modal')" >Cerrar</button>

                        </div>

                    </div>

                    <div class="col">

                        <button 
                            class="btn btn-success float-right"
                            @click="filtrar()"
                        >
                            Filtrar
                        </button>


                        <button 
                            class="btn btn-default float-right mr-3" 
                            @click="resetForm()" 
                        >
                            Limpiar
                        </button>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";
import Button from "../../../../common/Button.vue";
import { mapActions } from 'vuex';
import DatePicker from "vue2-datepicker";
import { getFiltersQuotation, getQuotationFilters } from '../../../../../constants/lineas';

export default {
    name: '',
    data() {
        return {
            quotation : {},
            naviera : [],
            quotation_number : "",
            from : "",
            to : "",

            navierasList : [],
            quotationsList : []
        };
    },
    props: {},

    components: {
        UiModal,
        Button,
        DatePicker
    },

    created() {},

    mounted() {
        this.getFilters();
    },

    methods: {

        ...mapActions(["ActionSetZindexModal"]),

        ...mapActions("lineas", [ 
            'actionSetDataDataTableQuotationImporter', 
            'actionSetDataDataTableQuotationImporterLoading',
        ]),

        openModal(ref){
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref){
            this.ActionSetZindexModal(false);
            this.$refs[ref].close();
        },

        async filtrar(){

            const payload  = {
                quotation_id : this.quotation.id ?? null,
                quotation_number : this.quotation_number ,
                naviera_id : this.naviera.map( n => n.id) ?? null,
                from : this.from ,
                to   : this.to ,
            };

            this.$vToastify.loader("Filtrando...");
            
            this.actionSetDataDataTableQuotationImporterLoading( true )  ;

            const { data } = await getQuotationFilters( payload ) ;

            this.actionSetDataDataTableQuotationImporter( data ) ;

            this.actionSetDataDataTableQuotationImporterLoading( false )  ;

            this.closeModal('modal');

            return this.$vToastify.stopLoader();
        },

        resetForm(){
            this.quotation        = {};
            this.naviera          = [];
            this.quotation_number = "";
            this.from             = "";
            this.to               = "";
        },
        async getFilters(){

            const { data : { navieras, quotations} } = await getFiltersQuotation();

            this.navierasList   = navieras ;
            this.quotationsList = quotations ;

        }
    },

    computed: {},

    watch: {},

    directives: {},

    filters: {}
};
</script>

<style>
    #idImportadorCotizacionesFiltros .container-fluid .mx-input{
        border: 0px;
        border-bottom: 1px solid #ccc;
        box-shadow: none;
        border-radius: 0px;
    }

    #idImportadorCotizacionesFiltros .container-fluid .label-datepicker{
        color: rgba(0, 0, 0, 0.54);
        font-size: 0.9375rem;
        margin-bottom: 0px;
    }
</style>

